import { cn } from '@/utils/classname';
import { inverted, Tooltip, TooltipContent, TooltipTrigger } from '@skand/ui';
import { ReactNode } from 'react';

export const ToolBarIconButtonV2 = ({
  analyticsEventObject,
  icon,
  tooltip,
  onClick,
  isActive,
  isDisabled,
}: {
  analyticsEventObject?: string;
  icon: ReactNode;
  tooltip: string | ReactNode;
  onClick?: () => void;
  isActive?: boolean;
  isDisabled?: boolean;
}) => {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <div
          aria-disabled={isDisabled}
          className={cn(
            'cursor-pointer justify-center items-center flex transition-colors',
            'h-8 w-8 b-1 b-solid b-neutral-100 rounded-6px color-neutral-100',
            'group-[[data-state=open]]:bg-primary-400',
            'data-[active=true]:bg-primary-400',
            'active:bg-primary-400',
            'aria-disabled:opacity-50 aria-disabled:cursor-not-allowed',
            !isDisabled && 'hover:bg-primary-500 bg-neutral-800/20',
          )}
          data-active={isActive ? 'true' : 'false'}
          data-analytics-event-object={analyticsEventObject}
          onClick={isDisabled ? undefined : onClick}
          role="button"
        >
          {icon}
        </div>
      </TooltipTrigger>

      <TooltipContent className="overflow-visible">
        {typeof tooltip === 'string' ? <span className={inverted}>{tooltip}</span> : tooltip}
      </TooltipContent>
    </Tooltip>
  );
};
